import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { hasRole } from "./roles";

export default function RequireAdmin({ children }) {
    const { user, loading } = useAuth();

    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;

    if (!hasRole(user, "admin")) {
        return <Navigate to="/manager" replace />;
    }

    return children;
}